import { render, staticRenderFns } from "./CollectionSearch.vue?vue&type=template&id=a8c28eac&scoped=true"
import script from "./CollectionSearch.vue?vue&type=script&lang=js"
export * from "./CollectionSearch.vue?vue&type=script&lang=js"
import style0 from "./CollectionSearch.vue?vue&type=style&index=0&id=a8c28eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c28eac",
  null
  
)

export default component.exports